<template>
	<app-page>
		<app-heading :title="isNew ? 'New Job' : job.name" />
		<app-row>
			<app-form @submit="onSubmit">
				<app-section style="width: 500px;" class="mt-4">
					<app-section-actions>
						<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
						<app-button type="submit" small color="primary" v-else>Save</app-button>
						<app-button type="cancel" small :to="{ name: 'system-cron' }">Cancel</app-button>
					</app-section-actions>
					<input-text
						label="Name"
						v-model="job.name"
						required
						:errors="errors.name"
					/>
					<input-text
						label="Display Name"
						v-model="job.display_name"
						required
						:errors="errors.display_name"
					/>
					<input-select
						label="Job type"
						:items="types"
						v-model="type"
					/>
					<div v-if="type === 'time'">
						<input-time-picker
							label="Time"
							v-model="job.time"
						/>
					</div>
					<div v-else>
						<app-row>
							<app-cell class="pl-0">
								<input-text
									type="number"
									label="Inteval"
									v-model="interval"
								/>
							</app-cell>
							<app-cell class="pr-0">
								<input-select
									:items="intervalSteps"
									v-model="intervalStep"
								/>
							</app-cell>
						</app-row>
					</div>
					<input-select
						label="State"
						:items="states"
						v-model="job.disabled"
					/>
				</app-section>
			</app-form>
		</app-row>
	</app-page>
</template>

<script>

const STEPS = {
	SECOND: 1,
	MINUTE: 60,
	HOUR: 60 * 60,
	DAY: 60 * 60 * 24,
	WEEK: 60 * 60 * 24 * 7,
	MONTH: 60 * 60 * 24 * 30,
}

export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				this.job = await this.$ravello.request()
					.to('system')
					.to('cron')
					.to(this.id)
					.get()

				this.init()
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			job: {
				name: '',
				display_name: '',
				time: null,
				interval: 0,
				disabled: false,
			},
			type: 'interval',
			types: [{
				text: 'Interval',
				value: 'interval',
			}, {
				text: 'Fixed time',
				value: 'time',
			}],
			states: [{
				text: 'Enabled',
				value: false,
			}, {
				text: 'Disabled',
				value: true,
			}],
			interval: 0,
			intervalStep: STEPS.SECOND,
			intervalSteps: [{
				text: 'Seconds',
				value: STEPS.SECOND,
			}, {
				text: 'Minutes',
				value: STEPS.MINUTE,
			}, {
				text: 'Hours',
				value: STEPS.HOUR,
			}, {
				text: 'Days',
				value: STEPS.DAY,
			}, {
				text: 'Weeks',
				value: STEPS.WEEK,
			}, {
				text: 'Months',
				value: STEPS.MONTH,
			}],
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.job
		},
		isNew() {
			return this.id === 'new'
		},
	},
	methods: {
		init() {
			if (this.job.time) {
				this.type = 'time'
			}

			const steps = Object.keys(STEPS).reverse()
			for (let i = 0; i < steps.length; i += 1) {
				const step = STEPS[steps[i]]
				if (this.job.interval >= step && this.job.interval % step === 0) {
					this.interval = this.job.interval / step
					this.intervalStep = step
					break
				}
			}
		},
		getRequestData() {
			return {
				name: this.job.name,
				display_name: this.job.display_name,
				time: this.type === 'time' ? this.job.time : null,
				interval: parseInt(this.interval || 0, 10) * this.intervalStep,
				disabled: this.job.disabled,
			}
		},
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request().to('system').to('cron').create(this.getRequestData())
				} else {
					await this.$ravello.request().to('system').to('cron').to(this.id)
						.update(this.getRequestData())
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Job successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'system-cron' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
